import {
  IBudgetPaymentMethod,
  TBudgetSigningMode,
} from 'modules/checkout/domain/entities';
import {
  PAYMENT_METHOD_TO_DOMAIN,
  TVectisPaymentMethodType,
} from 'shared/infra/adapters';

export interface IVectisPaymentMethod {
  key: TVectisPaymentMethodType;
  titulo: string;
  descricao: string;
  tipoAssinaturaContrato?: TBudgetSigningMode;
  elegivelParaFechamentoOrcamento?: {
    elegivel: boolean;
    mensagem?: string;
  } | null;
  maximoParcelas: number;
  valorParcela: number;
  percentualDesconto: number;
  precoDe: number;
  precoPor: number;
  percentualDescontoFormaPagamento: number;
  percentualDescontoFormaPagamentoEfetivo?: number;
  valorBaseParaDesconto?: number;
  valorDescontoTotal?: number;
  valorDescontoFormaPagamento: number;
  valorRecebimentoFormaPagamento?: number;
  diferencaParaValorPadraoOrcamento?: number;
  avisos?: string[] | null;
  bloquearFechamentoOrcamento?: boolean | null;
  parcelas?: {
    quantidade: number;
    valor: number;
    permiteRealizarPagamentoNessaCondicao?: boolean;
  }[];
}

export function buildPaymentMethod(
  method: IVectisPaymentMethod,
  fallbackSigningMode: TBudgetSigningMode,
): IBudgetPaymentMethod {
  return {
    key: PAYMENT_METHOD_TO_DOMAIN[method.key],
    title: method.titulo,
    description: method.descricao,
    signingMode: method.tipoAssinaturaContrato ?? fallbackSigningMode,
    eligibility: method.elegivelParaFechamentoOrcamento
      ? {
          eligible: method.elegivelParaFechamentoOrcamento.elegivel,
          message: method.elegivelParaFechamentoOrcamento.mensagem,
        }
      : undefined,
    warnings: method.avisos ?? [],
    blocksCheckout: method.bloquearFechamentoOrcamento ?? false,
    discount: {
      percentage: {
        default: method.percentualDesconto,
        byPaymentMethod: method.percentualDescontoFormaPagamento,
        applied: method.percentualDescontoFormaPagamentoEfetivo,
      },
      value: method.valorDescontoFormaPagamento,
    },
    values: {
      from: method.precoDe,
      to: method.precoPor,
      totalDiscount: method.valorDescontoTotal,
      discountInRelationToBudgetValue:
        method.diferencaParaValorPadraoOrcamento || 0,
    },
    installments: (method.parcelas ?? []).map(installment => ({
      number: installment.quantidade,
      value: installment.valor,
      allowed: installment.permiteRealizarPagamentoNessaCondicao ?? true,
    })),
  };
}

export function buildPaymentMethods(
  methods: IVectisPaymentMethod[],
  fallbackSigningMode: TBudgetSigningMode,
): IBudgetPaymentMethod[] {
  return (methods ?? [])
    .filter(method => !!method.key && !!PAYMENT_METHOD_TO_DOMAIN[method.key])
    .map(method => buildPaymentMethod(method, fallbackSigningMode));
}
